// caseHooks.js - Custom hooks for case management
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadCase,
  createCase,
  updateMetadata,
  deleteCase,
  emptyTrash,
  reset,
} from "./index";

/**
 * Hook for case management functionality
 */
export const useCase = () => {
  const dispatch = useDispatch();
  const caseState = useSelector((state) => state.case);

  // Load a case by ID
  const handleLoadCase = useCallback(
    (caseId) => {
      return dispatch(loadCase(caseId));
    },
    [dispatch]
  );

  // Create a new case
  const handleCreateCase = useCallback(
    (caseData) => {
      return dispatch(createCase(caseData));
    },
    [dispatch]
  );

  // Update case metadata
  const handleUpdateMetadata = useCallback(
    (caseData) => {
      return dispatch(updateMetadata(caseData));
    },
    [dispatch]
  );

  // Delete a case
  const handleDeleteCase = useCallback(
    (caseData) => {
      return dispatch(deleteCase(caseData));
    },
    [dispatch]
  );

  // Empty trash for a case
  const handleEmptyTrash = useCallback(
    (caseData) => {
      return dispatch(emptyTrash(caseData));
    },
    [dispatch]
  );

  // Reset case state
  const handleReset = useCallback(() => {
    return dispatch(reset());
  }, [dispatch]);

  return {
    // State
    case: caseState.case,
    isCreating: caseState.creating,
    isEmptying: caseState.emptyingTrash,
    isLoading: caseState.loading,
    isLoaded: caseState.loaded,
    isUpdating: caseState.updating,

    // Derived state
    isBusy: caseState.creating || caseState.loading || caseState.updating,
    hasCase: Object.keys(caseState.case).length > 0,

    // Actions
    loadCase: handleLoadCase,
    createCase: handleCreateCase,
    updateMetadata: handleUpdateMetadata,
    deleteCase: handleDeleteCase,
    emptyTrash: handleEmptyTrash,
    reset: handleReset,
  };
};
